<script setup lang="ts">
import RecommendationsCollection from "@/widgets/home/Recommended/RecommendationsCollection.vue";
import RecommendationsBanners from "@/widgets/home/Banners/RecommendationsBanners.vue";
import RecommendationsFiltersMenu from "@/widgets/home/Recommended/RecommendationsFiltersMenu.vue";
import PopularBrands from "@/widgets/home/PopularBrands/PopularBrands.vue";
import CapsulesWrapper from "@/widgets/home/Capsules/CapsulesWrapper.vue";

</script>
<template>
  <div class="filters-banners-brands-collection__wrapper">
    <recommendations-filters-menu />
    <capsules-wrapper />
    <recommendations-banners />
    <popular-brands />
    <recommendations-collection />
  </div>
</template>

<style scoped>
.filters-banners-brands-collection__wrapper {
  border-top-right-radius: 40px;
  border-top-left-radius: 40px;
  width: 100%;
  background: rgba(245, 245, 247, 1);
  position: relative;
  z-index: 4;
}
</style>
